import { render, staticRenderFns } from "./NewBuiltStowage.vue?vue&type=template&id=5030eff1&scoped=true&"
import script from "./NewBuiltStowage.vue?vue&type=script&lang=js&"
export * from "./NewBuiltStowage.vue?vue&type=script&lang=js&"
import style0 from "./NewBuiltStowage.vue?vue&type=style&index=0&id=5030eff1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5030eff1",
  null
  
)

export default component.exports